// extracted by mini-css-extract-plugin
export default {"header":"Header_header__JmfZA","logo":"Header_logo__Jsteg","logoDraw":"Header_logoDraw__lO9Ql","links":"Header_links__3b7YE"};